<template>
  <!-- Inicio do modal -->
  <div id="CardInPost">
    <b-modal
      ref="modalCard"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header-close
      size="xl"
    >
      <!-- Escolha de novo card ou card existente -->
      <div class="text-center">
        <h3>Lista de cards</h3>
      </div>
      <template v-if="card !== 'existing'">
        <div class="d-flex flex-column align-items-center">
          <span>Deseja criar um novo card ou adicionar um existente?</span>
          <div class="col-12 row">
            <div
              class="col-4 justify-content-center d-flex mt-5 align-items-end"
            >
              <button class="btn btn-large btn-secondary" @click="cancel()">
                Cancelar
              </button>
            </div>
            <div class="col-8 row">
              <div class="col-md-6 col-12 text-center mt-5">
                <button
                  class="btn btn-large btn-primario"
                  @click="choiceCard('new')"
                >
                  Novo card
                </button>
              </div>
              <div class="col-md-6 col-12 text-center mt-5">
                <button
                  class="btn btn-large btn-primario"
                  @click="choiceCard('existing')"
                >
                  Adicionar existente
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Modal para card existente -->
      <template v-if="card === 'existing'">
        <div class="row justify-content-md-center align-items-center">
          <div class="col-12 categories text-center">
            <b-tabs content-class="mt-3">

              <!-- For em todos as sessões -->
              <b-tab v-for="page in getAllPagesAndFilterExternalLink" :key="page.id">
                <!-- template para tornar o title do b-tab dinamico -->
                <template slot="title">
                  <span @click="loadPosts(page.id)">{{ page.name }}</span>
                </template>
                <!-- Masonry para os post de blog -->

                <div class="row" v-if="loadingPosts == true">
                  <spinner-grow-loading />
                </div>

                <masonry
                  v-else
                  :cols="{ default: 3, 1000: 2, 700: 1 }"
                  :gutter="{ default: '25px', 700: '15px' }"
                >
                  <!-- For para os somente os post de blog -->
                  <div
                    class="post-content"
                    v-for="post in posts"
                    :key="post.id"
                  >
                    <!-- Template para os cards de post -->
                    <div id="cardTemplate">
                      <!-- Se selecionado aplica a classe 'active' -->
                      <div
                        @click="isSelected(post.postId)"
                        class="card card-search"
                        :class="postSelected == post.postId ? 'active' : ''"
                      >
                        <div class="border-top">
                          <img
                            v-if="post.mainImage"
                            :src="CDN_URL + 'fit-in/0x350/' + post.mainImage"
                            class="card-img-top"
                          />
                          <img
                            v-else
                            src="@/assets/img/default-image.png"
                            class="card-img-top"
                          />
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-12 pt-2">
                              <h5
                                v-html="limitTitle(post.title)"
                                :title="normalizeTitle(post.title)"
                              ></h5>
                              <p class="card-summary">{{ post.summary }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </masonry>

                <!-- Botões para cards existentes -->
                <div v-if="card == 'existing'" class="col-12 row">
                  <div class="col-6 text-left mt-5">
                    <button
                      class="btn btn-large btn-secondary"
                      @click="cancel()"
                    >
                      Cancelar
                    </button>
                  </div>
                  <div class="col-6 text-right mt-5">
                    <button
                      :disabled="loading"
                      class="btn btn-large btn-primario float-right d-flex align-items-center"
                      @click="addCardExisting(pageID)"
                    >
                      Adicionar
                      <i v-if="loading" class="fal fa-spinner fa-spin fa-2x ml-2"></i>
                    </button>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </template>

      <!-- Modal para novos card -->
      <NewSection
        :newCardIndex="newCardIndex"
        v-if="addSessionModal"
        :sectionsCategories="categories"
        @returnAddSessionModal="addSessionModal = $event"
        @newCategories="categories = $event"
        :section="false"
        :postId="postId"
        @sessioncreated="cardCreated"
        :showAllOptions="false"
      />
    </b-modal>
  </div>
</template>

<script>
import NewSection from "@/components/organisms/NewSection";
import CardTemplate from "@/components/CardTemplate";
import { mapGetters, mapState } from "vuex";
import sectionsMixins from "@/mixins/sectionsMixins";
import apiMixins from "@/mixins/apiMixins";
import postMixins from "@/mixins/postMixins";

import SpinnerGrowLoading from "@/components/molecules/SpinnerGrowLoading";

export default {
  name: "CardInPost",
  data() {
    return {
      card: null, // new ou existing
      categories: [], //lista de sections
      CDN_URL: null,
      postSelected: null, // id selecionado
      addSessionModal: false, // true abre o modal de Sessions
      pageID: null, // id da pagina
      loading: false,
      loadingPosts: false,
      posts: []
    };
  },
  mixins: [sectionsMixins, apiMixins, postMixins],
  props: {
    postId: {
      required: true,
    },
    newCardIndex: {
      type: Number,
      required: false
    }
  },
  components: {
    NewSection,
    CardTemplate,
    SpinnerGrowLoading
  },
  watch: {
  },
  computed: {
    ...mapGetters("dashboardModule", ["getAllPosts", "getAllPagesAndFilterExternalLink"])
  },
  methods: {
    // Botão cancelar
    cancel() {
      this.$refs.modalCard.hide();
      this.$emit("cancel", false);
    },
    cardCreated() {
      this.cancel()
    },
    //Abre o modal para selecionar qual pagina existente quer adicionar
    async addCardExisting(sectionId) {
      this.loading = true;
      let data = { id: sectionId, index: this.newCardIndex };
      const url = `/site/${this.siteId}/post/${this.postId}/card`;
      const responseApi = await this.requestApiData(url, "post", data);

      if (responseApi.status == 1) {
        const update = await this.refreshPostEditorData(this.$session.get("siteId"), this.postId)
        this.cancel()
        this.scrollToSection(responseApi.id)
        //this.$router.go()
      } else {
        this.loading = false;
        alert("Ocorreu um erro.");
      }
    },
    // Define se vai add um new card ou existing
    choiceCard(state) {
      this.card = state;
      if (state == "new") {
        this.addSessionModal = true;
      }
    },
    async loadPosts(categoryId) {
      this.pageID = categoryId;

      this.posts = [];
      
      this.loadingPosts = true;

      this.posts = await this.loadSitePosts(this.$session.get("siteId"), categoryId);

      this.loadingPosts = false;
    },
    // edição dos titulos de card em post
    normalizeTitle(title) {
      if (title) {
        let normalized = title.replace("<p>", "");
        normalized = normalized.replace("</p>", "");
        normalized = normalized.replace(/&nbsp;/g, " ");
        return normalized;
      } else {
        return null;
      }
    },
    // edição dos titulos de card em post
    limitTitle(title) {
      if (title && title.length > 100) {
        return title.slice("0", "100") + "...";
      } else {
        return title;
      }
    },
    // define qual card existente esta selecionado, aplica class e define id para envio
    isSelected(id) {
      this.postSelected = id;
      this.pageID = id;
    },
  },
  created() {
    this.populateCategories();
    
    this.CDN_URL = process.env.CDN_URL;
  },
  mounted() {
    this.$refs.modalCard.show();
  },
};
</script>

<style scoped>
.border-top {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.card-body {
  padding: 0.75rem 1.25rem 0;
}
.card-search {
  border: 3px solid transparent !important;
  border-radius: 10px !important;
  transform: scale(0.97);
  transition: all 300ms;
}
.card-search:hover {
  transform: scale(1);
}
.card-search.active {
  border: 3px solid var(--main-color) !important;
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/CardInPost.vue